import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M168,113.074 L1751.02,113.074 L1751.02,0.001 L168,0.001 L168,113.074 Z M168,339.218 L1751.02,339.218 L1751.02,226.146 L168,226.146 L168,339.218 Z M464.929,1027.403 L544.985,1107.458 L900.712,751.618 L900.712,1920 L1013.785,1920 L1013.785,751.618 L1369.512,1107.458 L1449.568,1027.403 L957.249,535.197 L464.929,1027.403 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPageUpLine = /*#__PURE__*/function (_Component) {
  _inherits(IconPageUpLine, _Component);

  var _super = _createSuper(IconPageUpLine);

  function IconPageUpLine() {
    _classCallCheck(this, IconPageUpLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconPageUpLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPageUp",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPageUpLine.displayName = "IconPageUpLine";
  return IconPageUpLine;
}(Component);

IconPageUpLine.glyphName = 'page-up';
IconPageUpLine.variant = 'Line';
IconPageUpLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPageUpLine;
export { IconPageUpLine };